export const CHANGE_CURRENT_QUESTION = 'changeCurrentQuestion';
export const CHANGE_CURRENT_LEGAL_BASIS = 'changeCurrentLegalBasis';
export const CHANGE_CURRENT_TYPE = 'changeCurrentType';
// export const CHANGE_ACTIVITY_DESCRIPTION = 'changeActivityDescription';
export const ADD_TO_HISTORY = 'addToHistory';
export const REMOVE_FROM_HISTORY = 'removeFromHistory';
